import { render, staticRenderFns } from "./GreenFinanceAward2026.vue?vue&type=template&id=37cf9fac&scoped=true&"
import script from "./GreenFinanceAward2026.vue?vue&type=script&lang=js&"
export * from "./GreenFinanceAward2026.vue?vue&type=script&lang=js&"
import style0 from "./GreenFinanceAward2026.vue?vue&type=style&index=0&id=37cf9fac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cf9fac",
  null
  
)

export default component.exports